import { Chatbox } from "@talkjs/react";
import { Type } from "@themes/pollinator/ui/Type";
import { Loader } from "@themes/pollinator/ui/Loader";
import { usePlatformStore } from "@platform/store";
import { useTalkJSData } from "@platform/hooks/useChat";

export type Props = {};

export function VideoUIChat({}: Props) {
  const user = usePlatformStore((s) => s.user);

  const talkjsData = useTalkJSData();

  // Check if user has conversations
  const hasConversations =
    talkjsData?.conversations && talkjsData.conversations.length > 0;

  // Show all conversations for the user
  const conversations = talkjsData?.conversations || [];

  // Show loading state while data is being fetched
  if (!talkjsData || !user) {
    return (
      <div className="flex flex-col gap-8 px-4 py-8">
        <div className="flex flex-row gap-2 items-center">
          <Type variant="h3">Chat</Type>
        </div>
        <div className="flex flex-col gap-2">
          <Loader isFullPage />
          <Type variant="body2" className="text-brand-600 text-center">
            Loading chat data...
          </Type>
        </div>
      </div>
    );
  }

  if (!hasConversations) {
    return (
      <div className="flex flex-col gap-8 px-4 py-8">
        <div className="flex flex-row gap-2 items-center">
          <Type variant="h3">Chat</Type>
        </div>
        <div className="flex flex-col gap-2">
          <Type variant="h5" className="text-brand-800">
            No conversations available.
          </Type>
          <Type variant="body2" className="text-brand-700">
            You may need to be assigned to a circle to see conversations.
          </Type>
        </div>
      </div>
    );
  }

  return talkjsData.app_id && talkjsData.user_id && talkjsData.token ? (
    <>
      {conversations.map((conversationId) => (
        <Chatbox
          key={conversationId}
          conversationId={conversationId}
          theme="pollinator_theme"
          style={{ width: "100%", height: "100%" }}
          loadingComponent={<Loader />}
        />
      ))}
    </>
  ) : (
    <div className="flex flex-col h-full gap-4 items-center justify-center">
      <Type variant="body2">No conversations found.</Type>
    </div>
  );
}

export default VideoUIChat;
